import React, { Component } from 'react';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      acteurs: [],
    };
  }

  componentDidMount() {
    fetch('https://api.airtable.com/v0/appvaqBr3ffcBpd76/ECOSYSTEME%20DEEPTECH?api_key=key8oKvUvMrb16GYt')
    .then((resp) => resp.json())
    .then(data => {
      console.log(data);
      this.setState({ acteurs: data.records });
    }).catch(err => {
      // Error
    });
  }

  render() {
    return (

    <div className="container">
      <div className="glossary__search">
          <form className="glossary__search__form">
              <input className="form-control" id="glossarySearchInput" placeholder="Rechercher un acteur ..." type="search" />
          </form>
      </div>
      <div className="glossary__results mb-6">
        <div className="glossary__results__row">
          <div className="row">
                {this.state.acteurs.map(movie => <ActeursCards {...movie.fields} /> )}
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default App;

const ActeursCards = ({ NOM, TYPOLOGIE, SITE, LOGO, KEYWORD}) => (

  <div className="glossary__results__item col-sm-12 col-md-6 col-lg-4 col-xl-3" data-item={KEYWORD}>
    <div className="startup_card_item">
      <div className="sc-body">
          <div className="avatar">
              <img alt="image" src={LOGO[0].url} />
          </div>
          <div className="sc-info">
              <div className="h6 sc-name sc-name-acteur">{NOM}</div>
          </div>
      </div>
      <div className="sc-desc">{TYPOLOGIE}</div>

      <div className="sc-foot">

          <a className="extra-info" href={SITE}>
              <span>site</span>
              <i className="pg-icon">arrow_right</i>
          </a>

      </div>
    </div>
  </div>






);